import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronExpandBold';
/** Renders an SVG icon. */
const SvgChevronExpandBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.586 13.414a2 2 0 0 0 2.828 0L16 6.828l6.586 6.586a2 2 0 1 0 2.828-2.828l-8-8a2 2 0 0 0-2.828 0l-8 8a2 2 0 0 0 0 2.828m0 5.172a2 2 0 0 1 2.828 0L16 25.172l6.586-6.586a2 2 0 1 1 2.828 2.828l-8 8a2 2 0 0 1-2.828 0l-8-8a2 2 0 0 1 0-2.828"
      />
    </svg>
  );
};
SvgChevronExpandBold.displayName = displayName;
export default SvgChevronExpandBold;
